export default __webpack_public_path__ + "static/media/collapse-open-white.1f94c71c.svg";